const DEFAULT_MODULE = 'fw_ai'
const DEFAULT_ROLE_KEY = 'ANON'

const fallbackAccess = {
  description: '',
  can_submit_prompt: false,
  can_follow_up: false,
  can_start_new_conversation: false,
  can_click_actions: false,
  max_prompts: 0
}

/**
 * Returns the access control object for a given roleKey and module.
 * @param {string|null} roleKey - The role identifier (e.g., "LICENSE_FREE").
 * @param {object} config - The full user_role_settings config object.
 * @param {string} module - The feature module to evaluate (default is "fw_ai").
 * @returns {object} The module-level feature object with access flags.
 */
export function getModuleAccess(roleKey, config, module = DEFAULT_MODULE) {
  const roles = config?.roles || []
  const resolvedRoleKey = roleKey || DEFAULT_ROLE_KEY

  const role = roles.find(r => r.key === resolvedRoleKey)

  if (!role || !role.features || !role.features[module]) {
    return fallbackAccess
  }

  return role.features[module]
}
